/**
 * UI系の共通ユーティリティクラス
 */
class CommonUiUtil {
  // フラッシュメッセージの表示時間（ミリ秒）
  static FLASH_MESSAGE_TIMEOUT_MS = 5000;

  /**
   * フラッシュメッセージを表示する
   * @param {*} type "success" or "error"
   */
  static showFlashMessage(targetId, messages, type) {
    if(!messages || messages.length === 0) {
      return;
    }

    for (let message of messages) {
      // メッセージを個別に消去するため、IDを生成
      const id = `flash_${Date.now()}`;

      const alertType = type === 'success' ? 'alert-success' : 'alert-danger';
      document.getElementById(targetId).innerHTML += CommonUiUtil.makeFlashMessageHtml(id, message, alertType);

      // 生成したIDを対象にフラッシュメッセージを消す
      setTimeout(() => {
        $(`#${id}`).alert('close')
      }, CommonUiUtil.FLASH_MESSAGE_TIMEOUT_MS);
    }
  }

  /**
   * フラッシュメッセージのHTMLを生成する
   * @param alertType "alert-success" or "alert-danger"
   */
  static makeFlashMessageHtml(id, message, alertType) {
    return `
      <div id="${id}" class="alert alert-dismissible mx-2 mx-sm-4 mx-lg-5 mt-3 fade show ${alertType}">
        <button aria-label="Close" class="close" data-dismiss="alert">
          <span aria-hidden="true">×</span>
        </button>
        <div class="h5 m-0"><div class="text-center word-break-word">${message}</div></div>
      </div>
    `
  }

  /**
   * 指定のclass名を持つモーダルを閉じる
   */
  static closeModal(makerClassName) {
    // モーダルのマーカークラスの要素が存在しない場合は処理なし
    if (!document.getElementsByClassName(makerClassName)) {
      return;
    }

    // モーダルのマーカークラスが設定されているモーダルをすべて閉じる
    const elms = document.getElementsByClassName(makerClassName);
    for (let ii = 0; ii < elms.length; ii++) {
      const modalElm = elms[ii];
      if (!modalElm) {
        continue;
      }

      // モーダルを閉じる
      $(modalElm).modal('hide');
    }

    // モーダルの背景を削除（Bootstrapのクラス名に依存しているが、実装上許容する。。）
    $('.modal-backdrop').remove();
  }
}

// CommonUiUtilをwindowオブジェクトに公開（StimulusのJSコントローラーで参照できるようにするため、windowに設定）
window.CommonUiUtil = CommonUiUtil;
